import { BLOCK_NATIVE_DAPP_ID } from 'configs/config-main'
import { getNetworkIdFromHostname } from 'core/libs/lib-rpc-helpers'

let blocknative

export function setBlocknativeSDK() {

}

export function getBlocknativeSDK() {
}
